import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Button } from '../Kit/Buttons'
import { MdiUsers } from '../../assets/svg/MdiUsers'
import { AskJoinChatContainer, MainHeading } from './style'

export const AskJoinChat = ({ handleClick }) => {
  const { t } = useTranslation()
  return (
    <AskJoinChatContainer>
      <MainHeading textAlign="center" fontSize="1.125rem">
        {t('chat.askJoinButton')}
      </MainHeading>
      <Button
        display="flex"
        padding="0.5em 2.5em"
        textTransform="none"
        letterSpacing="0.063rem"
        variant="outlined"
        onClick={handleClick}
      >
        <MdiUsers />
        {t('chat.join')}
      </Button>
    </AskJoinChatContainer>
  )
}

AskJoinChat.propTypes = {
  handleClick: PropTypes.func.isRequired,
}
